import React from 'react';
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import DataTable from "../../components/data-table/DataTable";
import LeftBar from "../../components/left-bar/LeftBar";
import Content from "../../components/content/Content";
import {navLinks} from "../../services/organization";
import ActionButton from "../../components/button/ActionButton";
import ShowField from "../../components/fields/ShowField";
import {getFalseResult} from "../../services/common";
import {getEmployee, getEmployeeHistory} from "../../services/organization";
import {withRouter} from "react-router";

const columnData = [
    { id: 'dt', numeric: false, disablePadding: false, label: 'Дата и время', dateFormat: 'DD.MM.YYYY HH:mm:ss' },
    { id: 'user', numeric: false, disablePadding: false, label: 'Пользователь' },
    { id: 'field', numeric: false, disablePadding: false, label: 'Измененный параметр' },
    { id: 'oldValue', numeric: false, disablePadding: false, label: 'Значение "было"' },
    { id: 'newValue', numeric: false, disablePadding: false, label: 'Значение "стало"' },
];

@withRouter
class HistoryEmployeePage extends React.Component {

    state = {
        id: '',
        employee: {
            id: null,
            name: null,
            businessUnitId: null,
            employeeStatus: 'working',
            employeePost: 'master',
            departmentId: null,
            photo: null,
            parlour: null,
            address: null,
            employmentStart: new Date(),
            inn: null,
            comment: null,
            juridicalPersonId: null
        },
        refreshTable: false,
    };

    componentDidMount() {
        const path = this.props.location.pathname;
        const reId = new RegExp('[^/]+$');
        const resultId = reId.exec(path);
        if (resultId.length && resultId[0] !== '0') {
            this.setState({id: resultId[0], refreshTable: !this.state.refreshTable});

            getEmployee(resultId[0])
                .then(response => {
                    if (response.success) {
                        this.setState({
                            employee: response.data
                        })
                    }
                });
        }
    }

    handleClickBack = () => {
        this.props.history.push(`/organization/masters/view/${this.state.id}`);
    };

    getTableData = (...params) => {
        return this.state.id ? getEmployeeHistory(this.state.id, ...params) : getFalseResult();
    };

    render() {
        const { employee, refreshTable } = this.state;

        return (
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks} fakeLink="История изменения"/>}>
                    <ShowField
                        label="Имя"
                        value={employee.name}
                        fullWidth
                    />
                    {employee.parlour &&
                        <ShowField
                            label="Бизнес юнит"
                            value={employee.parlour.name}
                            fullWidth
                        />
                    }
                    <br />
                    <br />
                    <ActionButton onClick={this.handleClickBack}>Назад</ActionButton>
                </LeftBar>
                <Content title="История изменения сотрудника">
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        refresh={refreshTable}
                        selector={false}
                        order="desc"
                        orderBy="dt"
                    />
                </Content>
            </React.Fragment>
        );
    }
}

export default HistoryEmployeePage;
